import { Pages } from 'constants/menu'
import { SubPage } from 'components/left-submenu/LeftSubmenu'
import { CampaignDetailModelState } from '@urbanx/agx.campaigns.client'

export function getBuyerDetailsSubPages(
  campaignState?: CampaignDetailModelState
): SubPage[] {
  const subPages: SubPage[] = [
    {
      title: 'Buyer Information',
      link: Pages.BUYERS_INFORMATION,
    },
    {
      title: "Buyer's Solicitor",
      link: Pages.BUYERS_SOLICITOR,
    },
  ]

  if (campaignState === CampaignDetailModelState.QLD) {
    subPages.push({
      title: "Buyer's Agent",
      link: Pages.BUYERS_AGENT,
    })
  }

  return subPages
}
